import { createFileRoute, redirect } from '@tanstack/react-router';

import { queries } from '../common/api/queryKeys/queries';
import { AdvancedError } from '../common/Error/AdvancedError';
import { LoadingIndicator } from '../common/LoadingIndicator/LoadingIndicator';
import { EnquiryDraftPage } from '../order/create-enquiry/EnquiryDraftPage';
import { OrderModel, OrderState } from '../order/model/OrderModel';

export const Route = createFileRoute('/_app/orders_/draft/$id')({
    loader: async ({ context, params }) => {
        const order: OrderModel = await context.queryClient.ensureQueryData(queries.orders.detail(params.id));

        if (order.state !== OrderState.DRAFT) {
            throw redirect({ to: '/order/$id', params: { id: order.id } });
        }
    },
    component: EnquiryDraftPage,
    errorComponent: ({ error, reset }) => <AdvancedError error={error} resetError={reset} />,
    pendingComponent: () => <LoadingIndicator variant="page" />,
});
